export const GET_RECEIVINGFRUITS = "GET_RECEIVINGFRUITS";
export const GET_RECEIVINGFRUIT_UPDATE = "GET_RECEIVINGFRUIT_UPDATE";
export const COPY_RECEIVINGFRUIT = "COPY_RECEIVINGFRUIT"